<div class="tab-pane" [hidden]="!selected">
    <ng-content></ng-content>
</div>